export default {
  header: {
    projectName: 'اسم المشروع',
    export: 'تصدير',
    debug: 'تصحيح',
    success: 'نجاح',
    failed: 'فشل',
    generating: 'جاري إنشاء الفيديو...',
    updateNameFailed: 'فشل تحديث اسم المشروع',
    menu: 'قائمة',
    settings: 'الإعدادات',
    shortcuts: 'اختصارات لوحة المفاتيح',
    about: 'حول',
    darkMode: 'الوضع الداكن',
    lightMode: 'الوضع الفاتح',
    settingsComingSoon: 'ميزة الإعدادات قادمة قريباً',
    shortcutsComingSoon: 'ميزة اختصارات لوحة المفاتيح قادمة قريباً',
    aboutComingSoon: 'المعلومات حول قادمة قريباً',
    language: 'اللغة',
    dimensions: 'الأبعاد',
    canvas: 'لوحة الرسم',
    view: 'عرض',
    general: 'عام'
  },
  menu: {
    media: 'وسائط',
    text: 'نص'
  },
  loading: {
    core: 'جاري تحميل النظام...'
  },
  home: {
    title: 'ستوديو GeminiXiang',
    version: 'بيتا عام',
    betaDisclaimer: 'نسخة تجريبية، استمرارية البيانات غير مضمونة',
    newProject: 'مشروع جديد',
    backupFolder: 'مجلد النسخ الاحتياطي',
    documentation: 'توثيق',
    recentProjects: 'المشاريع الأخيرة',
    viewAll: 'عرض الكل ({count})',
    noProjects: 'لا توجد مشاريع بعد. أنشئ مشروعك الأول للبدء!',
    login: 'تسجيل الدخول',
    github: 'جيت هب',
    discord: 'ديسكورد',
    blog: 'مدونة',
    projectCreated: 'تم إنشاء المشروع',
    projectCreatedDesc: 'تم إنشاء مشروع جديد بنجاح',
    projectDeleted: 'تم حذف المشروع',
    projectDeletedDesc: 'تم حذف المشروع بنجاح',
    deleteConfirmation: 'هل أنت متأكد أنك تريد حذف هذا المشروع؟ لا يمكن التراجع عن هذا الإجراء.',
    migrationFailed: 'فشل النقل',
    migrationFailedDesc: 'فشل نقل البيانات من التخزين المحلي',
    loadFailed: 'فشل التحميل',
    loadFailedDesc: 'فشل تحميل المشاريع',
    creationFailed: 'فشل الإنشاء',
    creationFailedDesc: 'فشل إنشاء مشروع جديد',
    deletionFailed: 'فشل الحذف',
    deletionFailedDesc: 'فشل حذف المشروع'
  },
  timeline: {
    autoSaveFailed: 'فشل الحفظ التلقائي',
    autoSaveFailedDesc: 'فشل الحفظ التلقائي للمشروع',
    loadFailed: 'فشل التحميل',
    loadFailedDesc: 'فشل تحميل المشروع. إعادة توجيه إلى الصفحة الرئيسية...',
    mainTrack: 'المسار الرئيسي',
    undo: 'تراجع',
    redo: 'إعادة',
    split: 'تقسيم',
    delete: 'حذف'
  },
  attributes: {
    properties: 'الخصائص',
    position: 'الموقع',
    scale: 'المقياس',
    animation: 'الرسوم المتحركة',
    basic: 'أساسي',
    mute: 'كتم الصوت',
    text: 'نص',
    fontSize: 'حجم الخط',
    content: 'المحتوى',
    fontFamily: 'نوع الخط',
    direction: 'اتجاه النص',
    color: 'اللون',
    stroke: 'الحدود',
    background: 'الخلفية',
    video: 'فيديو',
    rotate: 'تدوير',
    backgroundColor: 'لون الخلفية',
    opacity: 'الشفافية',
    blend: 'دمج',
    filter: 'فلتر',
    effect: 'تأثير',
    transition: 'انتقال',
    speed: 'السرعة',
    volume: 'مستوى الصوت'
  },
  router: {
    editor: 'محرر الفيديو',
    preview: 'معاينة',
    storyboard: 'لوحة القصة - وكيل فيديو الذكاء الاصطناعي'
  },
  placeholder: {
    text: 'الرجاء إدخال محتوى النص',
    input: 'الرجاء الإدخال'
  },
  error: {
    parseAudio: 'فشل تحليل الصوت',
    parseImage: 'فشل تحليل الصورة',
    parseVideo: 'فشل تحليل الفيديو',
    noProject: 'الرجاء إنشاء أو فتح مشروع أولاً',
    invalidFileType: 'نوع ملف غير صالح'
  },
  media: {
    video: 'فيديو',
    image: 'صورة',
    audio: 'صوت',
    dropToUpload: 'أفلت الملفات هنا للتحميل'
  },
  common: {
    defaultText: 'نص افتراضي',
    delete: 'حذف'
  }
};
